"use client";
import {
  useCompositeGroupLabel
} from "../__chunks/ED7XMMMU.js";
import "../__chunks/TH2YTBRW.js";
import "../__chunks/3X3MDQGM.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/5M6RSQEC.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import "../__chunks/4R3V3JGP.js";

// src/menu/menu-group-label.ts
var TagName = "div";
var useMenuGroupLabel = createHook(
  function useMenuGroupLabel2(props) {
    props = useCompositeGroupLabel(props);
    return props;
  }
);
var MenuGroupLabel = forwardRef(function MenuGroupLabel2(props) {
  const htmlProps = useMenuGroupLabel(props);
  return createElement(TagName, htmlProps);
});
export {
  MenuGroupLabel,
  useMenuGroupLabel
};
